import { GamingAppCommand } from "@fabric-types/app-gaming";

export const CR0SS_SELL_FEATURE_FLAG_KEY = "cross-sell";

type CrossSellFeatureCommand =
	| GamingAppCommand.ShowCrossSellFeatureStatus
	| GamingAppCommand.HideCrossSellFeatureStatus;

export const CROSS_SELL_TOGGLE_FEATURE_COMMANDS: Record<string, CrossSellFeatureCommand> = {
	betslip: GamingAppCommand.ShowCrossSellFeatureStatus,
	quickBetslip: GamingAppCommand.HideCrossSellFeatureStatus,
};
